import { Box, Grid, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/system";



const FadeInBox = styled(Box)`
  animation: fadeIn 2s ease-out;
`;

const Home1 = () => {
  const navigate = useNavigate();
  const colors = {
    primary: "#FD0B0B",
    secondary: "#46B6FC",
    background: "#C7D6D5",
    textPrimary: "#0C120C",
    textSecondary: "#6D7275",
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100vh",
        color: "white",
        textAlign: "center",
        padding: 2,
        backgroundImage: `url("home11.jpeg")`,
        backgroundSize: {
          xs: "contain",
          md: "cover",
        },
      }}
    >
      <Grid container>
        <Grid item xs={12} sm={12} md={6} lg={5}>
          <FadeInBox
            sx={{
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              padding: 4,
              borderRadius: "12px",
              marginTop: "10vh",
            }}
          >
                  <Box
                  sx={{
                    marginLeft:'30px'
                  }}
                  >
                    <img
                      src="/ElektrotechnikEMN.png"
                      alt="ElektrotechnikEMN"
                      style={{
                        width: "150px",
                        height: "70px",
                        objectFit: "cover",
                        
                      }}
                    />
                  </Box>
            {/* <Typography
              variant="h3"
              sx={{
                fontWeight: "bold",
                textTransform: "uppercase",
                marginBottom: 2,
                color:'red',
                fontFamily: "Roboto Slab, serif",
                letterSpacing: 1,
                fontSize: { xs: "1.3rem", sm: "2rem" },
                fontStyle:'italic'
              }}
            >
              EMN
            </Typography>
            <Typography
              variant="h3"
              sx={{
                marginBottom: 2,
                fontSize: { xs: "1.3rem", sm: "2rem" },
                color:'red'
                

              }}
            >
              Elektrotechnik
            </Typography> */}

            <Typography
              sx={{
                fontSize: { xs: "1rem", sm: "1.2rem" },
                lineHeight: 1.6,
                marginBottom: 4,
                opacity: 0.8,
              }}
            >
              Wir bieten Ihnen die besten Lösungen für Ihre Elektronikbedürfnisse, sowohl für zu Hause als auch für Ihr Unternehmen.
            </Typography>

            <Box
              sx={{
                display: "flex",
                gap: 2,
                justifyContent: "center",
                flexDirection: { xs: "column", md: "row" },
              }}
            >
              {/* <Button
                variant="contained"
                sx={{
                  color: "white",
        borderColor: "black",
        backgroundColor:'black',
                  borderRadius: "10px",
                  textTransform: "none",
                  fontSize: "1.1rem",
                  transition: "background-color 0.3s ease, transform 0.3s ease",
                  "&:hover": {
                    transform: "scale(1.1)",
                  },
                }}
                onClick={() => (window.location.hash = "#services")}
              >
                Unsere Dienstleistungen
              </Button> */}

              <Button
                variant="variant"
                fullWidth
                sx={{
                  borderRadius: "10px",
                  textTransform: "none",
                  fontSize: "1.1rem",
                  transition: "all 0.3s ease",
                  backgroundColor: colors.primary,
                  borderColor: colors.primary,
                  color: "#fff",
                    "&:hover": 
                    {
                      backgroundColor: "red",
                      borderColor: "#fd0b0b",
                      color: "#fff",

                   
                    }
                }}
                onClick={() => navigate("/appointment")}
              >
                Termin buchen
              </Button>
            </Box>
          </FadeInBox>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Home1;
